/**
 * SubOrganisation Data Transfer Object
 * Represents a sub-organisation entity with all its properties
 */
export class SubOrganisationDTO {
    constructor() {
        this.id = 0;
        this.organizationId = '';
        this.name = '';
        this.address = '';
        this.email = '';
        this.phone = '';
        this.website = '';
        this.logo = '';
        this.description = '';
        this.status = '';
        this.isDefault = false;
    }

    /**
     * Creates a SubOrganisationDTO instance from API response data
     * @param {Object} apiData - Raw data from API response
     * @returns {SubOrganisationDTO} - Formatted SubOrganisationDTO instance
     */
    static fromApiResponse(apiData) {
        const subOrganisation = new SubOrganisationDTO();
        
        if (apiData) {
            subOrganisation.id = apiData.id || 0;
            subOrganisation.organizationId = apiData.organizationId || '';
            subOrganisation.name = apiData.name || '';
            subOrganisation.address = apiData.address || '';
            subOrganisation.email = apiData.email || '';
            subOrganisation.phone = apiData.phone || '';
            subOrganisation.website = apiData.website || '';
            subOrganisation.logo = apiData.logo || '';
            subOrganisation.description = apiData.description || '';
            subOrganisation.status = apiData.status || '';
            subOrganisation.isDefault = apiData.isDefault || false;
        }
        
        return subOrganisation;
    }

    /**
     * Converts the DTO to a format suitable for API requests
     * @returns {Object} - Plain object for API consumption
     */
    toApiRequest() {
        return {
            id: this.id,
            organizationId: this.organizationId,
            name: this.name,
            address: this.address,
            email: this.email,
            phone: this.phone,
            website: this.website,
            logo: this.logo,
            description: this.description,
            status: this.status,
            isDefault: this.isDefault
        };
    }
}

export default SubOrganisationDTO;
